














































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { View } from 'client-website-ts-library/plugins';
import { ItemCyclerImageSlide, ItemCyclerSlide } from '@/app_code/ItemCycler';
import ItemCycler from '@/components/Cycler/ItemCycler.vue';
import Modal from '@/components/Modal.vue';

@Component({
  components: {
    ItemCycler,
    Modal,
  },
})
export default class WhyWeAreGood extends Mixins(View) {
    private cyclerImages: ItemCyclerSlide[] = [
      new ItemCyclerImageSlide({ source: '/assets/images/home/slider/1', formats: ['avif', 'webp', 'jpg'], fallback: 'jpg' }),
      new ItemCyclerImageSlide({ source: '/assets/images/home/slider/2', formats: ['avif', 'webp', 'jpg'], fallback: 'jpg' }),
      new ItemCyclerImageSlide({ source: '/assets/images/home/slider/3', formats: ['avif', 'webp', 'jpg'], fallback: 'jpg' }),
    ];
}
